import { useContext } from 'react';
import { Store } from './Store';

export default function useDispatch() {
  const [, contextDispatch] = useContext(Store);

  return contextDispatch;
}
